<template>
    <swiper :options="swiperOption" class="partner-swiper">
      <swiper-slide  class="partner-swiper-item">
       <img src="@/assets/img/panter-img.png" />
      </swiper-slide>
    </swiper>
</template>

<script>
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper"; //局部引入

export default {

  name: 'PanterSwiper',

  components: {
    swiper,
    swiperSlide,
  },

  data() {
    return {
      swiperOption: {
          // autoplay: true,
          speed: 30000, //每个轮播图过渡的时间
          delay: 0, //每个轮播图间隔
          spaceBetween: 40, // slibe行距
          slidesPerView: 'auto', //当前页面显示几个，这里是auto
          loop: true, // 循环模式选项
          // grabCursor: true,
          centeredSlides: true,
          autoplay: {
            delay: 0,
            stopOnLastSlide: false,
            disableOnInteraction: false,
          },
      },
    };
  },

  mounted() {

  },

  methods: {

  },
};
</script>

<style lang="scss" scoped>
.partner-swiper {
  width: 1440px;
  height: 120px;
  border-radius: 0.1rem;
  overflow: hidden;
  transition-timing-function: linear !important;
  ::v-deep .swiper-wrapper{
    transition-timing-function: linear !important;
  }
}
.partner-swiper-item {
  width: 1826px !important;
  height: 120px;
  display: flex;
  flex-wrap: wrap;
  margin-right: 40px;
  img {
    // width: auto;
    height: 120px;
  }
}
</style>
